import React from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Form, Input} from "antd";
import {Translate} from "../../../components/util/translation.util";

type Props = {
    firstFieldName: string,
    secondFieldName: string,
    firstLabel: string,
    secondLabel: string,
    firstFieldConstraints: any,
    secondFieldConstraints: any,
    translationDomain: TranslationDomainEnum,
    onChange?: () => void,
    validateTrigger?: string,
};

export const RepeatedType: React.FC<Props> = ({
    firstFieldName,
    secondFieldName,
    firstLabel,
    secondLabel,
    translationDomain,
    firstFieldConstraints,
    secondFieldConstraints,
    validateTrigger
}) => {
    return (
        <>
            <Form.Item
                labelAlign={`left`}
                name={firstFieldName.split('.')}
                label={<Translate message={firstLabel} domain={translationDomain} />}
                rules={firstFieldConstraints}
                validateTrigger={validateTrigger}
            >
                <Input.Password />
            </Form.Item>
            <Form.Item
                labelAlign={`left`}
                name={secondFieldName.split('.')}
                label={<Translate message={secondLabel} domain={translationDomain} />}
                dependencies={[firstFieldName]}
                rules={secondFieldConstraints}
                validateTrigger={validateTrigger}
            >
                <Input.Password />
            </Form.Item>
        </>
    )
}